<template>
  <popup-modal ref="popup">
    <h2 style="margin-top: 0" class="mb-5">{{ title }}</h2>
    <div v-for="(el, key) in message" :key="key">{{ el }}</div>
    <div class="btns pt-8">
      <v-btn v-if="okButton" @click="_confirm" color="error">{{ okButton }}</v-btn>
      <v-btn v-if="cancelButton" @click="_cancel">{{ cancelButton }}</v-btn>
    </div>
  </popup-modal>
</template>
<script>
export default {
  components: {},

  data: () => ({
    title: undefined,
    message: undefined, // Main text content
    okButton: undefined, // Text for confirm button; leave it empty because we don't know what we're using it for
    cancelButton: undefined, // text for cancel button
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  methods: {
    show1(opts = {}) {
      this.title = opts.title || "Подтверждение";
      this.message = opts.message || "";
      this.okButton = opts.okButton || "Да";
      this.cancelButton = opts.cancelButton || "Отмена";

      this.$refs.popup.open();
      return new Promise((resolve) => (this.resolvePromise = resolve));
    },
    show(opts = {}) {
      this.title = opts.title;
      this.message = opts.message;
      this.okButton = opts.okButton;
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton;
      }
      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open();
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    _confirm() {
      this.$refs.popup.close();
      this.resolvePromise(true);
    },
    _cancel() {
      this.$refs.popup.close();
      this.resolvePromise(false);
    },
  },
};
</script>

<style scoped>
.btns {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.ok-btn {
  color: red;
  text-decoration: underline;
  line-height: 2.5rem;
  cursor: pointer;
}

.cancel-btn {
  padding: 0.5em 1em;
  background-color: #d5eae7;
  color: #35907f;
  border: 2px solid #0ec5a4;
  border-radius: 5px;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  cursor: pointer;
}
</style>
